import { REDIRECT_PATHS } from "@pages/AuthRedirects";
import { localstorageKeys } from "@const/store";

export default (storageService) => {
  const destination = window.location.href.replace(window.location.origin, "");
  if (REDIRECT_PATHS.includes(destination)) return;
  storageService.set(localstorageKeys.destination, destination);
};
